
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-21081a80\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./exercices.scss")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./exercices.ts"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-21081a80\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./exercices.vue.html"),
  /* scopeId */
  "data-v-21081a80",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/exercices/exercices.vue.html
// module id = V1Bm
// module chunks = 2